module.controller('sampleHomeDetailBaseCtrl', [ '$timeout', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'dateUtilService',
		'securityService', 'urlSampleDetail', sampleHomeDetailBaseCtrlFn ]);

function sampleHomeDetailBaseCtrlFn($timeout, $scope, $rootScope, $state, planSamplingService, alertService, dateUtil, securityService, urlSampleDetail) {

	var vm = $scope;

	vm.samples = [];
	vm.tip = {};
	
	vm.title = $state.current.data.title;

	vm.urlSampleDetail = urlSampleDetail;

	vm.pagination = {
		current : 1,
		total : 0
	};

	/*
	 * opciones para el qTip de fecha de programación
	 */
	vm.qtipScheduleDateOption = {
		style : 'qtip-dark  qtip-shadow'
	};

	vm.qtipClientOption = {
		style : 'qtip-dark  qtip-shadow'
	}

	vm.refreshSample = function(idPlan, idSampling, idSample) {
		planSamplingService.getSampleBasicInfo(idPlan, idSampling, idSample).then(function(response) {

			var sample = response.getData();
			sample.scheduleDate = dateUtil.formatMomentDateTime(sample.scheduleDate);
			sample.takenDate = dateUtil.formatMomentDateTime(sample.takenDate);
			sample.className = getConstantById(SAMPLE_STATE, sample.state).className;

			var idx = vm.samples.findIndex(function(s) {
				return s.id === idSample;
			});

			vm.samples[idx] = sample;

		}, function(response) {
		});
	}

	vm.onPageChange = function(page) {
		// se llama la funciton onPageChange del Filtro
		$scope.$$childHead.onPageChange(page);
	}

	// vm.activaTab = function(tab) {
	// $('.nav-pills a[href="#tab1"]').tab('show');
	// };

	function init() {
		

	}

	init();
}